export const MIN_PASSWORD_LENGTH = 8

// Mirrors the Supabase password policy (length + lower/upper/digit/symbol) so the UI can
// give live feedback instead of a server rejection. Supabase remains the authoritative gate;
// if you change the policy in the dashboard, update this list to match.
export const passwordRequirements: { label: string; test: (p: string) => boolean }[] = [
  {
    label: `At least ${MIN_PASSWORD_LENGTH} characters`,
    test: p => p.length >= MIN_PASSWORD_LENGTH,
  },
  { label: 'One lowercase letter', test: p => /[a-z]/.test(p) },
  { label: 'One uppercase letter', test: p => /[A-Z]/.test(p) },
  { label: 'One number', test: p => /[0-9]/.test(p) },
  { label: 'One symbol', test: p => /[^A-Za-z0-9]/.test(p) },
]

export const isPasswordValid = (p: string) => passwordRequirements.every(r => r.test(p))
